import {
    AllEvents,
    CardItem,
    createCardClickedEvent,
    PublicationCardItem,
} from '@news-mono/web-common'
import { MaybeLoaded } from 'json-react-layouts-data-loader'
import React from 'react'
import { getFundingType } from '../../../../../../templates/Publication/lib/get-funding-type'
import { Romeo } from '../../../../../../collections/PNRomeo/Romeo'
import { colorsPN } from '@news-mono/design-tokens'

interface PNInlineRelatedContentCardsProps {
    items: MaybeLoaded<PublicationCardItem[]>
    expectedCards: number
    onEvent: (event: AllEvents) => void
}
export const PNInlineRelatedContentCards: React.FC<PNInlineRelatedContentCardsProps> =
    (props) => {
        const storyClassification = true

        function linkClicked(
            e: React.MouseEvent<HTMLElement>,
            item: MaybeLoaded<CardItem>,
            cardNumber: number,
        ) {
            if (
                !item.loaded ||
                item.result.cardType === 'marketing-redirect-tile'
            ) {
                e.preventDefault()
                return
            }
            props.onEvent(
                createCardClickedEvent(
                    props.onEvent,
                    item.result,
                    'PerthNowInlineRelatedContentCards',
                    'InlineRelatedContent',
                    cardNumber,
                    getFundingType(item.result, storyClassification),
                    'InlineRelatedCollection',
                ),
            )
        }

        return (
            <Romeo
                itemClickEventHandler={linkClicked}
                items={props.items}
                expectedCards={
                    props.items.loaded ? props.items.result.length : 0
                }
                hideByline={true}
                hideCardFooter={true}
                horizontalDividerColor={colorsPN.stroke.weak}
                fixedRatios={'4:3'}
                cardSpacing={16}
                onEvent={props.onEvent}
                hideTopDivider={false}
                hideLastDivider={false}
                topBottomDividerColorOverride={colorsPN.stroke.brand.solid}
                fontScale={'M'}
                headerFontScale={'M'}
                headerFontOverride={{
                    mobile: '2XS',
                    tablet: 'XS',
                    desktop: 'M',
                }}
                imageSizeOverride={{
                    mobile: '2XS',
                    tablet: '2XS',
                    desktop: 'M',
                }}
            />
        )
    }
